import { composeIO } from 'react-compose-io'
import { lancamentoVariaveisIO } from './LancamentoVariaveis.IO'
import LancamentoVariaveisView from './LancamentoVariaveis.View'

export const LancamentoVariaveis = composeIO(LancamentoVariaveisView, lancamentoVariaveisIO)
